import { Component, ViewContainerRef, TemplateRef } from '@angular/core';
import { FaqCategory } from '../../models/faq/faq-category-model'
import { FaqCategoryService } from '../../services/faq/faq-category.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { MediaLibraryService } from '../../services/mediaLibrary/media-library.service';
import { MediaLibrary } from '../../models/mediaLibrary/media-library-model';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ProfileService } from '../../services/profile/profile.service';
import { RolePermissionService } from '../../services/role/role-permission.service';
@Component({
    selector: 'app-edit-faq-category',
    templateUrl: './edit-faq-category.component.html',
    styleUrls: ['./edit-faq-category.component.scss']
})
/** edit-faq-category component*/
export class EditFaqCategoryComponent {
  faqModel = new FaqCategory();
  faqID: string;
  errorMessage: any;
  fileToUpload: File;
  fd = new FormData();
  selectedFaqIcon: string;
  editFaqIcon: string;
  public mediaList: MediaLibrary[];
  userId: number;
  mediaImageShow: boolean;
  modalRef: BsModalRef;
  config = {
    animated: true
  };

    /** edit-faq-category ctor */
  constructor(private readonly faqService: FaqCategoryService, private readonly activatedRoute: ActivatedRoute, public toastr: ToastsManager, vcr: ViewContainerRef, private readonly router: Router,
    private readonly profileService: ProfileService, private readonly mediaServices: MediaLibraryService, private modalService: BsModalService,
    private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("faqcategory").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          if (create.length > 0) {
            this.activatedRoute.params.subscribe((params: Params) => {
              this.faqID = params['id'];
            });
            this.getFaq(this.faqID);
            this.toastr.setRootViewContainerRef(vcr);
            this.faqModel.sortOrder = 0;
            this.profileService.getProfile().subscribe(
              data => {
                if (data) {
                  this.userId = data.userID;
                }
                else {
                  this.userId = 0;
                }
              });
          }
          else {
            this.router.navigate(["/faq-categories"]);
          }
        }
        else {
          this.router.navigate(["/faq-categories"]);
        }
      }
    )
  }
  SlectImage(Image: MediaLibrary) {
    this.fileToUpload = null;
    this.fd = new FormData();
    this.editFaqIcon= Image.fileName;
    this.mediaList.forEach(x => {
      x.activeDiv = false;
    });
    Image.activeDiv = !Image.activeDiv;
  }
  HidePopup() {
    this.editFaqIcon = "";
    this.modalRef.hide();
  }
  ShowImage() {
    this.selectedFaqIcon = "";
    this.faqModel.faqCategoryIcon = this.editFaqIcon;
    this.modalRef.hide();
  }
  OpenMediaPopup(template: TemplateRef<any>, ImageFor: string) {
    this.mediaServices.getMediaLibraryFor(ImageFor).subscribe(
      data => {
        this.mediaList = data;
        if (this.mediaList.length > 0) {
          this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
        }

      }
    )
  }
  uploadFaqIcon(file: FileList) {
    this.fileToUpload = file.item(0);
    this.fd.append("FaqCategoryIcon", this.fileToUpload);
    ////Show image preview
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.faqModel.faqCategoryIcon = "";
      this.mediaImageShow = true;
      this.selectedFaqIcon = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
  }
  onSubmit() {
    if (this.faqModel.sortOrder == null) {
      this.faqModel.sortOrder = 0;
    }
    this.faqService.updateFaqCategory(this.faqModel).subscribe(result => {
      if (result) {
        this.fd.append("FaqCategoryID", result.toString());
        this.faqService.SaveFaqCategoryIcon(this.fd, this.userId);
        this.toastr.success('FAQ Category has been Updated.', 'Success');

        setTimeout(() => {
          this.router.navigate(["/faq-categories"]);
        }, 2000);
      }
      else {
        this.toastr.error('Error occurred. Oop!', 'Success');
      }
    });
  }
  getFaq(faqid: string) {
    this.faqService.getFaqCategory(faqid).subscribe(
      data => {
        this.faqModel = data
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/faq-components/edit-faq-category/edit-faq-category.component.ts